var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilter = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00332 4H16.9967C17.5499 4 18 4.45009 18 5.00332C18 5.55655 17.5499 6.00664 16.9967 6.00664H3.00332C2.45009 6.00977 2 5.55968 2 5.00332C2 4.45009 2.45009 4 3.00332 4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53457 8.9917H14.4644C15.0177 8.9917 15.4678 9.44179 15.4678 9.99502C15.4678 10.5483 15.0177 10.9983 14.4644 10.9983H5.53457C4.98134 10.9983 4.53125 10.5483 4.53125 9.99502C4.53125 9.44179 4.98134 8.9917 5.53457 8.9917Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9342 13.98H8.06777C7.51454 13.98 7.06445 14.4301 7.06445 14.9833C7.06445 15.5365 7.51454 15.9866 8.06777 15.9866H11.9342C12.4874 15.9866 12.9375 15.5365 12.9375 14.9833C12.9375 14.4301 12.4874 13.98 11.9342 13.98Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilter);
export default ForwardRef;